import m from "mithril";

import { yearPath } from "../lib/routes";
import { Data } from "../lib/data";

export class HomePage {
  view() {
    return(
      <>
        {Data.map((datum) => {
          return <a
            href={yearPath(datum.year)}
            class="button year-button"
          >{datum.year}</a>
        })}
      </>
    );
  }
}
